import { render, staticRenderFns } from "./TableSwitch.vue?vue&type=template&id=d880ac40&scoped=true&"
import script from "./TableSwitch.vue?vue&type=script&lang=js&"
export * from "./TableSwitch.vue?vue&type=script&lang=js&"
import style0 from "./TableSwitch.vue?vue&type=style&index=0&id=d880ac40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d880ac40",
  null
  
)

export default component.exports